import { render, staticRenderFns } from "./payrollSummaryApproval.vue?vue&type=template&id=23c4a50e&scoped=true&"
import script from "./payrollSummaryApproval.vue?vue&type=script&lang=js&"
export * from "./payrollSummaryApproval.vue?vue&type=script&lang=js&"
import style0 from "./payrollSummaryApproval.vue?vue&type=style&index=0&id=23c4a50e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23c4a50e",
  null
  
)

export default component.exports